import { render, staticRenderFns } from "./answerrang.vue?vue&type=template&id=0e43f1b7&scoped=true&"
import script from "./answerrang.vue?vue&type=script&lang=js&"
export * from "./answerrang.vue?vue&type=script&lang=js&"
import style0 from "./answerrang.vue?vue&type=style&index=0&id=0e43f1b7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e43f1b7",
  null
  
)

export default component.exports